import { baseService } from "../base";
import { GetInventoryTemplatesParams, InventoryTemplate } from "./inventory-templates.types";

export const inventoryTemplatesApi = {
  getActive: async () => {
    const { data } = await baseService.get<InventoryTemplate[]>("/inventory-templates/active");
    return data;
  },

  getAll: async (params?: GetInventoryTemplatesParams) => {
    const { data } = await baseService.get<InventoryTemplate[]>("/inventory-templates", { params });
    return data;
  },

  getById: async (id: string) => {
    const { data } = await baseService.get<InventoryTemplate>(`/inventory-templates/${id}`);
    return data;
  },

  create: async (payload: Partial<InventoryTemplate>) => {
    const { data } = await baseService.post<InventoryTemplate>("/inventory-templates", payload);
    return data;
  },

  update: async (id: string, payload: Partial<InventoryTemplate>) => {
    const { data } = await baseService.patch<InventoryTemplate>(`/inventory-templates/${id}`, payload);
    return data;
  },

  delete: async (id: string) => {
    await baseService.delete(`/inventory-templates/${id}`);
  },
};
